import PropTypes from 'prop-types';
import React from 'react';
import styles from './NotEnabledMessage.less';
import PhoneIcon from '../../../shared/components/Svg/PhoneIcon';
import UpgradeStrip from '../UpgradeStrip/UpgradeStrip';
import PhoneUtils from '@wix/wixrest-utils/dist/PhoneUtils';
import Modal from '../../../shared/components/Modal/Modal';
import _ from 'lodash';
import { MODAL_A11Y_IDS } from '../../../shared/constants';
import { isTab } from '../../../shared/utils/A11yHelpers';

export default class extends React.Component {
    static displayName = 'NotEnabledMessage';

    static propTypes = {
        isEnabled: PropTypes.bool,
        onClose: PropTypes.func,
        onPublish: PropTypes.func,
        isCustomDesign: PropTypes.bool,
        preview: PropTypes.bool,
        restaurant: PropTypes.object,
        form: PropTypes.object,
        reservation: PropTypes.object,
        isMobile: PropTypes.bool
    };

    componentDidMount() {
        const { interactions, onPublish } = this.props;

        if (interactions['full-reservation-submit']) {
            onPublish({type: 'interaction', name: 'full-reservation-submit'});
        }
    }

    render() {
        const { isCustomDesign, restaurant, preview, content, isMobile } = this.props;
        const upgradeStrip = this._getUpgradeStrip();
        const title = this._getTitle();
        const phone = _.get(restaurant, 'contact.phone', '');
        const countryCode = _.get(restaurant, 'address.countryCode', '');
        const displayPhone = PhoneUtils.displayPhone(phone, countryCode);

        return (
            <Modal onClose={this._closePopup} isFreemium={upgradeStrip !== null} isPreview={preview}
                   closeButtonRef={el => this.modalCloseButton = el} restaurant={restaurant}
                   onCloseShiftFocus={this._confirmButtonFocus}
                   isCustomDesign={isCustomDesign}
                   fullScreen={isMobile}
                   className={`${styles.modal} ${isCustomDesign ? styles.custom : ''} ${isMobile ? styles.mobile : ''}`}
                   XDimension={isMobile ? 15 : 16}
                   margintTop={preview ? -48 : 0}>
                <div className={`${styles.stage} ${preview ? styles.preview : ''}`}>
                    {upgradeStrip}
                    <div className={styles.innerWrapper}>
                        <div className={styles.icon}><PhoneIcon /></div>
                        <div className={styles.title} id={MODAL_A11Y_IDS.TITLE_ID}>{title}</div>
                        <div className={styles.description} id={MODAL_A11Y_IDS.DESCRIPTION_ID}>
                            <div>{content.get('description')}</div>
                            <div className={styles.phone}><a aria-labelledby={MODAL_A11Y_IDS.DESCRIPTION_ID} href={`tel:${displayPhone}`}>{displayPhone}</a></div>
                        </div>
                        <button ref={el => this.doneButtonElem = el} className={styles.button} onClick={this._closePopup} onKeyDown={this._onButtonKeyDown}>{content.get('confirm')}</button>
                    </div>
                </div>
            </Modal>
        );
    }

    _getTitle = () => {
        const { content, isEnabled } = this.props;
        const key = isEnabled ? 'title' : 'closed_title2';
        return content.get(key);
    };

    _getUpgradeStrip = () => {
        const { preview, content } = this.props;
        return preview ? (
            <UpgradeStrip
                onPremium={this._onPremiumClick}
                onSecondaryButton={this._tryReservationsClick}
                primaryButtonText={content.get('preview_header_upgrade_button')}
                secondaryButtonText={content.get('preview_header_button')}
                tip={content.get('preview_header_helptip')}
                text={content.get('preview_header_text')}/>
        ) : null;
    };

    _onPremiumClick = () => {
        const { onPublish } = this.props;
        onPublish({type: 'upgrade'});
    };

    _tryReservationsClick = () => {
        const { onPublish } = this.props;
        onPublish({type: 'preview'});
    };

    _closePopup = () => {
        this.props.onClose();
    };

    _confirmButtonFocus = () => {
        if (this.doneButtonElem) {
            this.doneButtonElem.focus();
        }
    };

    _onButtonKeyDown = (e) => {
        const { tab, shiftKey } = isTab(e);

        if (tab && !shiftKey && this.modalCloseButton) {
            this.modalCloseButton.focus();
            e.preventDefault();
        }
    };
}
